export const WEB_BETA = process.env.NEXT_PUBLIC_BP_WEB_BETA === "1";
export const WEB_APP = WEB_BETA || process.env.NEXT_PUBLIC_BP_WEB_APP === "1";
export const WEB_BETA_ETIQUETAS = WEB_BETA && process.env.NEXT_PUBLIC_BP_WEB_BETA_ETIQUETAS === "1";

export function usarExperienciaDesktop() {
  return WEB_APP;
}
